"use client";

import axios, { AxiosInstance } from "axios";
import { setupRequestInterceptor, setupResponseInterceptor } from "./interceptors";

const API_URL = process.env.API_URL || "http://localhost:8000";

if (!process.env.API_URL) {
  console.warn("API_URL não está definido. Usando fallback: http://localhost:8000");
}

/**
 * Create Axios client instance with interceptors
 */
export const createApiClient = async (): Promise<AxiosInstance> => {
  const api = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 300000,
  });

  setupRequestInterceptor(api);
  setupResponseInterceptor(api);

  return api;
};

/**
 * Create Axios client instance sem interceptores de resposta.
 * Utilizado para requisições que não devem disparar o fluxo de refresh de token
 * (ex: a própria chamada de refresh-token).
 */
export const createRawApiClient = (): AxiosInstance => {
  return axios.create({
    baseURL: API_URL,
    headers: {
      "Content-Type": "application/json",
    },
    timeout: 300000,
  });
};

let apiClientInstance: AxiosInstance | null = null;

/**
 * Get singleton Axios client instance
 */
export const getApiClient = async () => {
  if (!apiClientInstance) {
    apiClientInstance = await createApiClient();
  }
  return apiClientInstance;
};
